// extracted by mini-css-extract-plugin
export default {"playGame":"PlayGame_playGame__ghuQR","header":"PlayGame_header__wfVbh"};